import { ReactNode } from 'react';
import { tailwindOverride } from '@getsynapse/design-system';
import emptyProjectsTable from 'assets/icons/empty-projects.svg';

const RenderNoRecords = ({
  imageSrc,
  caption,
  children,
  dataCy,
  dataTestId,
  className,
  imageClassName,
  imageAlt = 'React Logo',
  labelClassName,
  wrapperClassName,
}: {
  imageSrc?: any;
  caption?: string;
  children?: ReactNode;
  dataCy?: string;
  dataTestId?: string;
  className?: string;
  imageClassName?: string;
  imageAlt?: string;
  labelClassName?: string;
  wrapperClassName?: string;
}) => {
  let defaultImageToShow = emptyProjectsTable;
  let captionToUse: string | undefined = caption;

  return (
    <div
      data-cy={dataCy}
      data-testid={dataTestId}
      className={tailwindOverride(
        'bg-neutral-white flex justify-center items-center border-t-0',
        { 'h-99': !className },
        className
      )}
    >
      <div
        className={tailwindOverride(
          'flex flex-col items-center',
          wrapperClassName
        )}
      >
        <img
          className={tailwindOverride('m-auto self-center', imageClassName)}
          src={imageSrc || defaultImageToShow}
          alt={imageAlt}
        />

        {captionToUse && (
          <span
            className={tailwindOverride(
              'm-auto mt-6 self-center text-base text-neutral-black',
              labelClassName
            )}
          >
            {captionToUse}
          </span>
        )}

        {children && children}
      </div>
    </div>
  );
};

export default RenderNoRecords;
